import { Enums } from '../common/enums'

import { IOpData } from '../util/interfaces'

import { OpDataType } from '../core/op-data-type'
import { OpDataTypeGroup } from '../core'


export class OpDataTypeGroupData implements IOpData {

    // Properties

    public IdDataTypeGroupData: number
    public IdDataTypeGroup: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // Properties end


    // NavigationProperties

    public dataType: OpDataType
    public dataTypeGroup: OpDataTypeGroup

    // NavigationProperties end

    //#region Custom properties

    public referencedObject: any
    public previousValue: any

    //#endregion


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // IOpChangeState implementation

    public opState: Enums.OpChangeState

    // IOpChangeState implementation end


    // IOpData implementation

    public get idData() { return this.IdDataTypeGroupData }
    public set idData(idData: number) { this.IdDataTypeGroupData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // IOpData implementation end

    public toString() {
        return "DataTypeGroupData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.IdDataTypeGroupData = opObj.IdDataTypeGroupData
            this.IdDataTypeGroup = opObj.IdDataTypeGroup
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.value = opObj.Value
            this.opState = opObj.OpState

            this.previousValue = opObj.PreviousValue
            this.referencedObject = opObj.ReferencedObject

            if (opObj._DataType != null) {
                this.dataType = new OpDataType(opObj._DataType)
            }

            if (opObj.DataTypeGroup != null) {
                this.dataTypeGroup = new OpDataTypeGroup(opObj.DataTypeGroup)
            }
        } else {
            this.IdDataTypeGroupData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            IdDataTypeGroupData: this.IdDataTypeGroupData,
            IdDataTypeGroup: this.IdDataTypeGroup,
            IdDataType: this.idDataType,
            IndexNbr: this.indexNbr,
            Value: this.value,
            OpState: this.opState
        }
    }

    public static fromIOpData(data: IOpData): OpDataTypeGroupData {
        const newData: OpDataTypeGroupData = new OpDataTypeGroupData(null)

        newData.IdDataTypeGroupData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}